import { handleActions } from 'redux-actions'
import * as type from './type'

export const initialState = {
    stateResponsibleList: [],
    fetching: false,
    error: null,
}


export default handleActions({
    [type.FIND_STATE_RESPONSIBLE_LIST_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_STATE_RESPONSIBLE_LIST_SUCCESS]: (state, action) => {
        const { stateResponsibleList } = action.payload
        return {
            ...state,
            stateResponsibleList,
            fetching: false,
        }
    },
    [type.FIND_STATE_RESPONSIBLE_LIST_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_STATE_RESPONSIBLE]: (state, action) => {
        const { stateResponsibleId, name, value } = action.payload
        return {
            ...state,
            stateResponsibleList: state.stateResponsibleList.map(stateResponsible => {
                return stateResponsible.id !== stateResponsibleId ? stateResponsible : {
                    ...stateResponsible,
                    [name]: value,
                }
            }),
        }
    },

    [type.SAVE_STATE_RESPONSIBLE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.SAVE_STATE_RESPONSIBLE_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.SAVE_STATE_RESPONSIBLE_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/process/state/state-responsible/reducer.js